import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { type RenderVariant, ToggleField } from '@atlassian/company-hub-common';

import { CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE } from '../../../../constants';
import type { UpdateMainFormFieldType } from '../../../../controllers/use-cards-extension-parameters-and-actions/types';
import type { CardsExtensionParameters } from '../../../../types';
import { messages } from './messages';

type PaddingToggleProps = {
	isPaddingEnabled: CardsExtensionParameters['isPaddingEnabled'];
	renderVariant: RenderVariant;
	updateMainFormField: UpdateMainFormFieldType;
};

export const PaddingToggle = ({
	isPaddingEnabled,
	renderVariant,
	updateMainFormField,
}: PaddingToggleProps): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const handleChange = useCallback(() => {
		updateMainFormField({ isPaddingEnabled: !isPaddingEnabled });

		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'toggle',
				actionSubjectId: 'paddingToggle',
				source: CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE,
				attributes: {
					renderVariant,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, isPaddingEnabled, renderVariant, updateMainFormField]);

	return (
		<ToggleField
			label={formatMessage(messages.paddingLabel)}
			isChecked={isPaddingEnabled}
			onChange={handleChange}
		/>
	);
};
